import borderRadius from 'theme/global/border-radius';
import boxShadow from 'theme/global/box-shadow';

export default {
  borderRadius,
  boxShadow,
};
